module.exports = __webpack_public_path__ + "static/media/h5_yoga_pic1.ff811b94.png";